import { CustomError } from "./CustomErrors";
import { PresetErrorCodes } from "./PresetErrors";

export enum UserErrorCodes {
  INVALID_USERNAME = "invalid_username",
  RESERVED_USERNAME = "reserved_username",
  USERNAME_TAKEN = "username_taken",
  UNKNOWN = "unknown",
}

export function userErrorMessageForCode(code: UserErrorCodes) {
  switch (code) {
    case UserErrorCodes.USERNAME_TAKEN:
      return "Username Taken, please choose a different one";
    case UserErrorCodes.INVALID_USERNAME:
      return "Username Invalid, Usernames must be at least 3 characters long and can only contain letters, numbers, and underscores.";
    case UserErrorCodes.RESERVED_USERNAME:
      return "Username is special value and cannot be used, please chose a different one";
  }
  return "Something went wrong, try a different username";
}
export class UserError extends CustomError<UserErrorCodes> {
  constructor(code: UserErrorCodes, message = "error occurred") {
    super(message, code);
    Object.setPrototypeOf(this, UserError.prototype);
  }
}
